import React, { Component } from 'react';
import Input from 'Components/Input';
import Dropdown from 'Components/Dropdown/dropdown';
import { DateRangePicker } from 'react-dates';
import { ReactComponent as UploadIcon } from "Icons/upload-blue.svg";
import {ReactComponent as DeleteIcon} from 'Icons/delete.svg';
import Upload from 'Components/Upload';
import Moment from 'moment';
import Cx from 'classnames';
import { isEmami, isSapDPL } from 'Utils/index';

const contract_types = [
    {contract_type: 1, contract_name: 'LCL Contract'},
    {contract_type: 2, contract_name: 'Courier Contract'},
    {contract_type: 3, contract_name: 'Dedicated Contract'},
    {contract_type: 4, contract_name: 'CFA Contract'},
    {contract_type: 5, contract_name: 'FTL Contract'},
]


class ContractDetails extends Component {
    constructor() {
        super();
        this.state = {

        }
    }

    onCancel = () => {
        this.props.onClickBack();
    }

    onNext = () => {
        this.props.onChangePage(2);
    }

    validate = () => {
        const { data } = this.props;
        let errorFlag = true;
        if(data.rfq_name && data.vendor_name && data.contract_tenure_from && data.contract_tenure_to && data.docs.length > 0 && data.contract_type_id) {
            errorFlag = false
        }
        return errorFlag;
    }

    getContractTypes = () => {
        let contractTypes = [...contract_types];
        if(isEmami()) {
            contractTypes = (contract_types || []).filter(el => el.contract_type === 3);
        }
        return contractTypes;
    }

    getVendorDetails = () => {
        const { vendorlist, transportersList } = this.props;
        let vendor = vendorlist;
        if(isEmami() || isSapDPL()) {
            vendor = (transportersList || []).map(el => {
                return {
                    company: el.name,
                    company_id: el.id,
                    ...el
                }
            })
        }
        return vendor;
    }

    render() {
        const { data, isView, isEdit, contractExist } = this.props;
        const vendorDetails = this.getVendorDetails();

        return (
            <div className='pv-20 ph-20'>
                <div className={Cx('ht-90 flex flex-between pv-20 ph-20 bg-white br-5', {
                    'disable-pointer-events': isView
                })} style={{'border': '1px solid #85919E'}}>
                    <div className='wt-400 mr-20'>
                            <div className='fs-16 fSemibold mb-2'>Contract Name <span style={{ color: 'red' }}>*</span></div>
                            <Input 
                                className="ht-36 border-dblue br-5"
                                placeholder={'Contract Name'}
                                value={data.rfq_name}
                                onChange={(e) => this.props.onChange(e, 'rfq_name')}
                            />
                    </div>
                    <div className='wt-400 mr-20'>
                            <div className='fs-16 fSemibold mb-2'>Transporter Name <span style={{ color: 'red' }}>*</span></div>
                            <Dropdown 
                                className="border-dblue" 
                                inputClassName={" ht-15"}
                                widthValue={'wt-400'}
                                items={vendorDetails}
                                name="vendor_name" 
                                displayKey="company" 
                                label="Select Vendor"
                                selectedItem={data.vendor_name && vendorDetails.find(el => el.company === data.vendor_name)}
                                onSelect={(name) => {
                                    const vendor = (vendorDetails || []).find(el => el.company === name) || {};
                                    this.props.onSelect({
                                        name: vendor.company,
                                        value: vendor.company_id
                                    }, 'vendor_name', 'vendor_id');
                                }}
                            />
                            {contractExist && <div className='error-color fs-14 fBold mt-5'>Contract Already Exist for this Vendor, Please change the branch to create a new contract</div>}
                    </div>
                    <div>
                            <div className='fs-16 fSemibold mb-2'>Contract Tenure <span style={{ color: 'red' }}>*</span></div>
                            <DateRangePicker 
                                className="ht-36 br-2"
                                startDate={!data.contract_tenure_to ? Moment(data.contract_tenure_from || null) : Moment(data.contract_tenure_from)}
                                startDateId="startDate"
                                endDate={data.contract_tenure_to ? Moment(data.contract_tenure_to) : null}
                                endDateId="endDate"
                                onDatesChange={({ startDate, endDate }) => {
                                    this.props.onDatesChange(startDate, endDate);
                                }}
                                focusedInput={this.state.focusedInput}
                                onFocusChange={focusedInput => this.setState({ focusedInput: true ? focusedInput : null })}
                                displayFormat={'DD MMM YYYY'}
                                noBorder={true}
                                minimumNights={0}
                                isOutsideRange={(date) => false}
                            />
                    </div>
                </div>
                <div className={Cx('mt-20 ht-90 pv-20 ph-20 bg-white br-5', {
                    'disable-pointer-events': (isView||isEdit)
                })} style={{'border': '1px solid #85919E'}}>
                    <div className='fs-20 header-color fSemibold'>Contract Types and Details </div>
                    <div className='content-bgColor pv-20 ph-10 mt-5 br-2'>
                            <div className="fs-16 fSemibold" style={{'color': '#27335D'}}>Service Type <span style={{ color: 'red' }}>*</span></div>
                            <div className='flex flex-between mt-20'>
                                {(this.getContractTypes() || []).map((contract, cIndex) => (
                                <button className={Cx('contract-button fs-16', {
                                    'active': contract.contract_type === data.contract_type_id
                                })} onClick={() => this.props.onSelectContractType(contract.contract_type , contract.contract_name)}>
                                    {contract.contract_name}
                                </button>))}
                            </div>
                    </div>
                </div>
                <div className={Cx('mt-20 ht-90 pv-20 ph-20 bg-white br-5', {
                    'disable-pointer-events': isView
                })} style={{'border': '1px solid #85919E'}}>
                    <div className='fs-20 header-color fSemibold'>Contract Document Upload <span style={{ color: 'red' }}>*</span></div>
                        <div className='content-bgColor pv-20 ph-10 mt-5 br-2 flex'>
                            <div className='upload-doc mr-30'>
                                <Upload onChange={this.props.uploadDocument} className="theme-color fs-16" fileSize={40}>
                                    <UploadIcon className="wt-18 ht-18 ml-20 curP"/>
                                    <span className='ml-5 fSemibold'>Upload here</span>
                                </Upload>
                            </div>
                            <div className='theme-color flex'>
                                {(data.docs || []).map((doc, index) => <div className='mt-5'>
                                    <a onClick={() => this.props.downloadUploadedFile(doc.name)}>{doc.name}</a>
                                    <DeleteIcon className={'wt-18 ht-18 ml-20 curP'} onClick={() => this.props.deleteDoc(index)}></DeleteIcon>
                                </div>)}
                            </div>
                        </div>
                </div>
                <div className='flex flex-right mt-20'>
                    <button className='border-dblue wt-150 ht-40 fs-16 fSemibold dark-blue mr-30' onClick={this.onCancel}>Cancel</button>
                    <button className={Cx('button-bg-color wt-150 ht-40 fs-16 fSemibold white-color', {
                        'notselectable': this.validate() || contractExist
                    })} onClick={this.onNext}>Next</button>
                </div>
            </div>
        )
    }
}

export default ContractDetails;